module.exports = __webpack_public_path__ + "img/sec4desk.b26b8395.png";